import { createContext, useContext, type RefObject } from "react";

const PickerListElementContext =
    createContext<RefObject<HTMLElement | null> | null>(null);

export const PickerListElementProvider = PickerListElementContext.Provider;

/** The enclosing `Picker.List`'s scroll element, or `null` for a part rendered outside one. */
export const usePickerListElementRef = () =>
    useContext(PickerListElementContext);
